/**
 * Aviso no contexto (contrato `InlineAlert` do catalogo do design system).
 *
 * PROMOVIVEL: recebe tom e conteudo, e nao sabe o que e card, relatorio ou sessao.
 *
 * Existe porque aviso escrito como paragrafo solto some no meio do painel: o "Card ignorado - ..."
 * e o alerta de regerar ficavam como uma linha laranja qualquer, do mesmo peso do texto ao redor.
 * Aqui o tom vira desenho (barra na lateral e fundo lavado), sem virar caixa pesada.
 *
 * SEGUNDA COPIA (a primeira e do New Inteli Graph). Copiado, e nao reescrito, de proposito: os dois
 * apps precisam da mesma peca e o design system ainda nao a exporta. **Na terceira copia, sobe para
 * `@ledger-glass/react`** - tres implementacoes da mesma coisa divergem, duas ainda se mantem em dia.
 */

import type { ReactNode } from 'react'

export type AlertTone = 'info' | 'warning' | 'danger'

export interface AlertProps {
  tone?: AlertTone
  children: ReactNode
  /** Acao de recuperacao: "Tentar de novo", "Limpar filtros". */
  action?: ReactNode
}

export function Alert({ tone = 'info', children, action }: AlertProps) {
  return (
    <div className={`alert alert--${tone}`} role={tone === 'info' ? undefined : 'alert'}>
      <div className="alert__body">{children}</div>
      {action === undefined ? null : <div className="alert__action">{action}</div>}
    </div>
  )
}
